import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "../logo-meducar-app.png";

const CRONTU_URL = "https://crontu.com.ar/";

export default function SelectProfile() {
  const navigate = useNavigate();

  const handlePatient = () => {
    window.location.href = CRONTU_URL;
  };

  const handleProfessional = () => {
    navigate("/register");
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-5 relative font-sans">
      <div className="absolute top-6 left-6 z-10">
        <a href="/select-profile">
          <img src={logo} alt="meducar" className="h-9 w-auto block" />
        </a>
      </div>

      <div className="w-full max-w-[900px] pt-12">
        <div className="text-center mb-8">
          <img src={logo} alt="meducar" className="h-12 w-auto mx-auto hidden xs:block" />
        </div>

        <h2 className="text-center text-[28px] font-bold text-[#333] mb-2">
          ¿QUÉ ESTÁS BUSCANDO?
        </h2>
        <p className="text-center text-[#666] mb-10">
          Te ayudamos a encontrar lo que buscás. Elegí tu perfil para continuar
        </p>

        <div className="flex flex-wrap justify-center gap-6 mt-8">
          {/* Card Paciente */}
          <div className="flex-1 min-w-[300px] max-w-[420px] mb-5">
            <div
              onClick={handlePatient}
              className="h-full min-h-[320px] rounded-xl p-8 sm:p-10 text-center cursor-pointer transition-all duration-300 border-2 border-[#3388ff] flex flex-col justify-between"
              style={{
                background: "linear-gradient(to bottom, rgba(51, 136, 255, 0.1) 0%, #FFFFFF 100%)",
              }}
            >
              <div>
                <div className="mb-5 flex justify-center w-[100px] h-[100px] mx-auto text-[#3388ff]">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="w-full h-full"><path fill="currentColor" d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"/></svg>
                </div>
                <h3 className="text-lg font-bold text-[#3388ff] mb-4 uppercase leading-tight">
                  SOY PACIENTE<br />Y QUIERO SOLICITAR UN TURNO
                </h3>
                <p className="text-sm text-[#3388ff] mb-8">
                  Buscá un profesional en Crontu y agendá tu consulta de forma rápida y segura
                </p>
              </div>
              <button
                type="button"
                onClick={(e) => { e.stopPropagation(); handlePatient(); }}
                className="w-full bg-[#3388ff] text-white border-0 rounded-[25px] py-3 px-6 text-sm font-bold cursor-pointer uppercase hover:bg-[#2976cc] transition-colors"
              >
                SOLICITAR TURNO
              </button>
            </div>
          </div>

          {/* Card Profesional */}
          <div className="flex-1 min-w-[300px] max-w-[420px] mb-5">
            <div
              onClick={handleProfessional}
              className="h-full min-h-[320px] rounded-xl p-8 sm:p-10 text-center cursor-pointer transition-all duration-300 border-2 border-[#31C7B2] flex flex-col justify-between"
              style={{
                background: "linear-gradient(to bottom, rgba(49, 199, 178, 0.1) 0%, #FFFFFF 100%)",
              }}
            >
              <div>
                <div className="mb-5 flex justify-center w-[100px] h-[100px] mx-auto text-[#31C7B2]">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="w-full h-full"><path fill="currentColor" d="M447.1 112c-34.2.5-62.3 28.4-63 62.6-.5 24.3 12.5 45.6 32 56.8V344c0 57.3-50.2 104-112 104-60 0-109.2-44.1-111.9-99.2C265 333.8 320 269.2 320 192V36.6c0-11.4-8.1-21.3-19.3-23.5L237.8.5c-13-2.6-25.6 5.8-28.2 18.8L206.4 35c-2.6 13 5.8 25.6 18.8 28.2l30.7 6.1v121.4c0 52.9-42.2 96.7-95.1 97.2-53.4.5-96.9-42.7-96.9-96V69.4l30.7-6.1c13-2.6 21.4-15.2 18.8-28.2l-3.1-15.7C107.7 6.4 95.1-2 82.1.6L19.3 13C8.1 15.3 0 25.1 0 36.6V192c0 77.3 55.1 142 128.1 156.8C130.7 439.2 208.6 512 304 512c97 0 176-75.4 176-168V231.4c19.1-11.1 32-31.7 32-55.4 0-35.7-29.2-64.5-64.9-64zm.9 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"/></svg>
                </div>
                <h3 className="text-lg font-bold text-[#31C7B2] mb-4 uppercase leading-tight">
                  SOY PROFESIONAL DE LA SALUD<br />Y QUIERO CREAR MI CUENTA
                </h3>
                <p className="text-sm text-[#31C7B2] mb-8">
                  Registrá tu centro médico y administralo de manera sencilla.
                </p>
              </div>
              <button
                type="button"
                onClick={(e) => { e.stopPropagation(); handleProfessional(); }}
                className="w-full bg-[#31C7B2] text-white border-0 rounded-[25px] py-3 px-6 text-sm font-bold cursor-pointer uppercase hover:bg-[#2ab3a0] transition-colors"
              >
                CREAR CUENTA
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
